import React from 'react';
import styled from 'styled-components';

const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #324156;
  line-height: 15px;
  padding-bottom: 10px;
`;

export default Title;
